module.exports = __webpack_public_path__ + "img/brich-equipment-black.f7506ff1.jpeg";